export default __webpack_public_path__ + "static/media/user-interface.5363b1b7.png";